import { useState } from 'react'
import { formatDateTime, roleLabel, sourceLabel } from './labels'
import { userTitle } from './identity'
import { useUserSearch } from './queries'
import styles from './merge-dialog.module.css'

type Props = {
  readonly targetId: string
  readonly active: boolean
  readonly onPick: (id: string) => void
}

export function MergeSearch({ targetId, active, onPick }: Props) {
  const [q, setQ] = useState('')
  const search = useUserSearch(q, active)
  const items = (search.data?.items ?? []).filter((u) => u.id !== targetId)

  return (
    <>
      <label className={styles.field}>
        <span className="muted">Имя или email второго аккаунта</span>
        <input type="search" value={q} autoFocus onChange={(e) => setQ(e.target.value)} placeholder="Минимум 2 символа" />
      </label>
      {search.isFetching && <div className="spinner" aria-label="Загрузка" />}
      {search.isError && <p className="error-box">Поиск не сработал, попробуйте ещё раз.</p>}
      {search.data && items.length === 0 && <p className="muted">Никого не нашли.</p>}
      {items.length > 0 && (
        <ul className={styles.results}>
          {items.map((u) => (
            <li key={u.id}>
              <button type="button" className={styles.result} onClick={() => onPick(u.id)}>
                <span>{userTitle(u).title}</span>
                <span className={styles.meta}>
                  {[u.email, roleLabel(u.role), sourceLabel(u.signup_source), u.telegram_linked ? 'Telegram' : null, formatDateTime(u.created_at)]
                    .filter(Boolean)
                    .join(' · ')}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
